import Vue from 'vue'
import App from '@/App'
import Router from 'vue-router'
import router from '@/router'
import store from '@/store/index'
import 'element-ui/lib/theme-chalk/index.css';


import {
  Container, Aside, Menu, Submenu, MenuItem, MenuItemGroup, Header,
  Dropdown, DropdownItem, DropdownMenu, Main, Table, TableColumn,
  Form, FormItem, Input, Button, Row, Col,Autocomplete, Pagination,
  Dialog, Select, Option, OptionGroup, Checkbox, CheckboxGroup, Radio,
  RadioGroup, DatePicker, TimePicker, Switch, Tag, Tooltip, Message, MessageBox,
  Cascader,Upload, Tree, Popover, InputNumber, CascaderPanel, Image, Card, Empty,  Tabs,
  TabPane, Icon, Loading, PageHeader
} from 'element-ui';

import '@/styles/quill.core.css';
import '@/styles/common.scss';

Vue.prototype.$message = Message       //vue实例上挂载Message

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location)
}

Vue.prototype.$showLoading = function() {
  return this.$loading({
    lock: true,
    text: '处理中',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.prototype.$ELEMENT = { zIndex: 1000 };
Vue.use(Container)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Header)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Main)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Button)
Vue.use(Col)
Vue.use(Row)
Vue.use(Autocomplete)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Select)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Switch)
Vue.use(Tag)
Vue.use(Tooltip)
Vue.use(Cascader)
Vue.use(Upload);
Vue.use(Tree);
Vue.use(Popover);
Vue.use(InputNumber);
Vue.use(CascaderPanel);
Vue.use(Image);
Vue.use(Card);
Vue.use(Empty);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Icon);
Vue.use(Loading);
Vue.use(PageHeader);

Vue.use(router)
Vue.config.productionTip = false
Vue.prototype.$confirm=MessageBox.confirm;


import './permission';

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

